/** @format */

import { produce } from "immer";
import React, { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { useLocale } from "../../i18n/hooks";
import { Card } from "../../resources/types";
import VisualEditor, {
  getDataWithoutCollaboration,
} from "../../VisualEditor/VisualEditor";
import { setIsLoading } from "../contentEditorSlice";

type Props = {
  card: Card;
  initCard: Card;
  updateCard: (value: Card) => void;
  tabType: "answer" | "extension" | "hint";
};

const AddTab: React.FC<Props> = ({ card, initCard, updateCard, tabType }) => {
  const [timer, setTimer] = useState<NodeJS.Timeout>();

  const locale = useLocale();
  const dispatch = useAppDispatch();

  const updateCardTab = (value: string) => {
    updateCard(
      produce(card, (draft) => {
        let initialObject = draft.Object[tabType];

        if (!initialObject || typeof initialObject === "string") {
          initialObject = {
            en: "",
            cy: "",
          };
        }

        draft.Object[tabType] = { ...initialObject, [locale]: value };
      }),
    );
  };

  return (
    <div className={`${tabType}-container`}>
      <div className={`w-100 bg-auto bg-white rounded mt-2 mb-3`}>
        <VisualEditor
          editorId={`${tabType}-${card.UUID}-${locale}`}
          aria-label={`Edit ${tabType}`}
          data={
            (typeof initCard?.Object[tabType] === "object"
              ? initCard?.Object[tabType]?.[locale]
              : (initCard?.Object[tabType] as string)) ?? ""
          }
          onChange={async (_, editor) => {
            clearTimeout(timer);
            dispatch(setIsLoading(true));
            const newTimer = setTimeout(async () => {
              if (editor !== null) {
                await getDataWithoutCollaboration(editor).then((data) => {
                  updateCardTab(data);
                  dispatch(setIsLoading(false));
                });
              }
            }, 500);

            setTimer(newTimer);
          }}
        />
      </div>
    </div>
  );
};

export default AddTab;
